/* eslint-disable react/jsx-props-no-spreading */
import {
  useRouteMatch,
  Switch,
  Route
} from 'react-router-dom';
import HOC from '../HOC';
import RF from './RF';
import LM from './LM';
import MUM from './MUM';

const LessonDetails = () => {
  const { url } = useRouteMatch();
  return (
    <div>
      <Switch>
        <Route
          path={`${url}/rf/:id?`}
          render={() => <RF />}
        />
        <Route
          path={`${url}/lm/:id?`}
          render={() => <LM />}
        />
        <Route
          path={`${url}/mum/:oidx`}
          render={() => <MUM />}
        />
      </Switch>
    </div>
  );
};

export default HOC(LessonDetails);
